import { render, staticRenderFns } from "./Scene2.vue?vue&type=template&id=29f606a6&scoped=true"
import script from "./Scene2.vue?vue&type=script&lang=js"
export * from "./Scene2.vue?vue&type=script&lang=js"
import style0 from "./Scene2.vue?vue&type=style&index=0&id=29f606a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f606a6",
  null
  
)

export default component.exports